package oldframes.campaigns

import bootstrap.*
import ru.it_mozaika.utils.checkResponseError
import oldcomponents.NotyType
import oldcomponents.page.Breadcrumb
import oldcomponents.page.PageHeaderProps
import oldcomponents.page.pageContent
import oldcomponents.page.widget
import oldcomponents.reactEChartsCore
import oldcomponents.showNotification
import io.ktor.client.call.*
import js.core.jso
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.datetime.*
import kotlinx.dom.appendElement
import kotlinx.html.*
import mui.material.Box
import mui.material.ButtonColor
import mui.material.TabsVariant
import mui.system.sx
import org.w3c.dom.*
import react.*
import react.dom.*
import react.dom.aria.AriaRole
import react.dom.aria.ariaControls
import react.router.dom.Link
import react.router.useNavigate
import react.router.useParams
import ru.it_mozaika.components.commonButtonComponent
import ru.it_mozaika.sender.common.models.EmailCampaignStatistics
import ru.it_mozaika.sender.common.models.Sender
import ru.it_mozaika.sender.common.models.Store
import ru.it_mozaika.sender.common.models.SubscriptionList
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.sender.js.application.components.campaigns.campaignsStatisticsDownloadDialog
import web.cssom.*
import mui.icons.material.InfoSharp
import mui.icons.material.MultilineChartSharp
import mui.icons.material.MouseSharp
import mui.material.IconPosition

val emailCampaignStatisticsFrame = fc<EmailCampaignFrameProps> { props ->
    val navigate = useNavigate()

    val params = useParams()
    val id = params["id"].orEmpty()

    val (activeTab, setActiveTab) = useState(0)
    var activePreviewTab by useState(0)

    var statistics by useState<EmailCampaignStatistics>()
    var store by useState<Store>()
    var sender by useState<Sender>()
    var list by useState<SubscriptionList>()

    val r = useRef<IFRAME>()
    var bodyElements by useState(mapOf<Int, HTMLElement>())
    var clicksInitialized by useState(listOf<Int>())

    val (showCampaignStatisticsDialog, setShowCampaignStatisticsDialog) = useState(false)

    useEffect {
        if (statistics != null && activeTab == 2) {
            (0 until props.campaign.variants.size).forEach { index ->
                if (!bodyElements.containsKey(index)) {
                    (document.getElementById("preview$index") as? HTMLIFrameElement)?.let { frame ->
                        if ((frame.contentDocument?.body?.childElementCount ?: 0) > 0) {
                            bodyElements = bodyElements.plus(index to frame.contentDocument?.body!!)
                        } else {
                            frame.onload = {
                                bodyElements = bodyElements.plus(index to frame.contentDocument?.body!!)
                                it
                            }
                        }
                    }
                }
//                (document.getElementById("preview$index") as? HTMLIFrameElement)?.let { frame ->
//                    println("preview $index frame")
//                    println("${frame.contentDocument != null} ${frame.contentDocument?.body != null} ${frame.contentDocument?.body?.childElementCount}")
//                    frame.onload = {
//                        println("preview $index frame onLoad")
//                        bodyElements = bodyElements.plus(index to frame.contentDocument?.body!!)
//                        println("$bodyElements")
//                        it
//                    }
//                }
            }
//            val elements = (0 until props.campaign.variants.size).mapNotNull { index ->
//                (document.getElementById("preview$index") as? HTMLIFrameElement)?.contentDocument?.body as? HTMLBodyElement
//            }
//            bodyElements = elements
//            for(i in 0 until props.campaign.variants.size) {
//                document.getElementById("preview$i")?.let {
//
//                }
//
//            }
        }
    }

    useEffect(bodyElements, activeTab, activePreviewTab) {
        if (activeTab != 2 || bodyElements.size != props.campaign.variants.size || clicksInitialized.contains(activePreviewTab))
            return@useEffect

        bodyElements[activePreviewTab]?.let { body ->
            clicksInitialized = clicksInitialized.plus(activePreviewTab)
            body.appendElement("div") {
                this.setAttribute("style", "position: absolute;width: 100%; height: 100%; z-index: 10000; left: 0; top: 0;")
                body.getElementsByTagName("a").let { links ->
                    val stats = statistics?.clicks?.get(activePreviewTab)?.clicks?.associate { it._id to it.count } ?: mapOf()
                    val max = statistics?.clicks?.get(activePreviewTab)?.clicks?.maxOf { it.count } ?: 1
                    for (i in 0 until links.length) {
                        links[i]?.let { link ->
//                            val idx = link.getAttribute("ses:tags").orEmpty().split(";").find { it.startsWith("idx") }?.substringAfter("idx:")?.toIntOrNull() ?: -1
//                            val idx = i+1
                            stats[i]?.let { count ->
                                appendElement("div") {
                                    val size = 30 + (30 * (count.toFloat()/max)).toInt()
                                    link.getBoundingClientRect().let { rect ->
                                        val left = (rect.left + rect.width / 2.0f).toInt() - size / 2
                                        val top = (rect.top + rect.height / 2.0f).toInt() - size / 2
                                        this.setAttribute("style", "position: absolute;left: ${left}px;top:${top}px;border-radius: 50%; background-color: #5d5386f0; color: white; font-size: 1.2rem; width: ${size}px; height: ${size}px; text-align: center; line-height: ${size}px;")
                                    }
                                    this.textContent = count.toString()
                                }
                            }
                        }

                    }
                }
            }
        }
    }


    useEffect(props.campaign) {
        Http.get("/stores/${props.campaign.store}") { response ->
            store = response.checkResponseError()?.let { error ->
                showNotification(error, NotyType.Error)
                null
            } ?: response.body()
        }
        Http.get("/senders/${props.campaign.sender}") { response ->
            sender = response.checkResponseError()?.let { error ->
                showNotification(error, NotyType.Error)
                null
            } ?: response.body()
        }
        Http.get("/subscribers/lists/${props.campaign.subscriptionList}") { response ->
            list = response.checkResponseError()?.let { error ->
                showNotification(error, NotyType.Error)
                null
            } ?: response.body()
        }
        Http.get("/campaigns/${props.campaign.id}/statistics") { response ->
            response.checkResponseError()?.let { error ->
                showNotification(error, NotyType.Error)
                return@get
            }
            statistics = response.body()
        }
    }

    campaignsStatisticsDownloadDialog{
        attrs.isOpen = showCampaignStatisticsDialog
        attrs.onClose = { setShowCampaignStatisticsDialog(false) }
        attrs.campaign = props.campaign.id
    }

    child(pageContent) {
        attrs.headerProps = jso<PageHeaderProps>().apply {
            header = props.campaign.name
            breadcrumbs = listOf(
                Breadcrumb("/", "", "ti ti-home"),
                Breadcrumb("/campaigns", "Массовые рассылки", ""),
                Breadcrumb("/campaigns/$id", "Просмотр", ""),
            )
        }
        attrs.active = props.active

        div("row flex-row") {
            child(widget) {

                div("row d-flex justify-content-end mr-2 ml-2 mb-2") {
                    Link {
                        attrs.to = "/campaigns/$id/preview"
                        Button {
                            attrs.type = web.html.ButtonType.button
                            attrs.variant = "primary"
                            attrs.className = ClassName("mr-3")
                            i("la la-eye") {}
                            attrs.onClick = { e ->
                                e.preventDefault()
                                window.open("/campaigns/${id}/preview", "_blank")
                            }
                            +"Предпросмотр"
                        }
                    }
                    Link {
                        attrs.to = "/campaigns/new?id=$id"
                        Button {
                            attrs.type = web.html.ButtonType.button
                            attrs.variant = "primary"
                            attrs.className = ClassName("mr-3")
                            i("la la-copy") {}
                            +"Скопировать"
                        }
                    }
                    commonButtonComponent{
                        attrs.buttonColor = ButtonColor.primary
                        attrs.label = "Скачать статистику"
                        attrs.onButtonClick = {
                            setShowCampaignStatisticsDialog(true)
                        }

                    }
                }
                Box{
                    attrs.role = AriaRole.tabpanel

                    mui.material.Tabs {
                        attrs.sx {
                            this.paddingTop = 5.px
                            this.fontSize = FontSize.large
                            this.fontStyle = FontStyle.oblique
                            this.fontVariant = FontVariant.unicase
                        }

                        attrs.variant = TabsVariant.fullWidth
                        attrs.value = activeTab
                        attrs.onChange = { _, value ->
                            val newValue = value as Int
                            setActiveTab(newValue)
                        }
                        mui.material.Tab {
                            attrs.value = 0
                            attrs.label = ReactNode("Основная информация")
                            attrs.id = "campaign-statistics-tab-${0}"
                            attrs.ariaControls = "campaign-statistics-tabpanel-${0}"
                            attrs.icon = InfoSharp.create()
                            attrs.iconPosition = IconPosition.top

                        }
                        mui.material.Tab {
                            attrs.value = 1
                            attrs.label = ReactNode("Статистика")
                            attrs.id = "campaign-statistics-tab-${1}"
                            attrs.ariaControls = "campaign-statistics-tabpanel-${1}"
                            attrs.icon = MultilineChartSharp.create()
                            attrs.iconPosition = IconPosition.top

                        }
                        mui.material.Tab {
                            attrs.value = 2
                            attrs.label = ReactNode("Карта кликов")
                            attrs.id = "campaign-statistics-tab-${2}"
                            attrs.ariaControls = "campaign-statistics-tabpanel-${2}"
                            attrs.icon = MouseSharp.create()
                            attrs.iconPosition = IconPosition.top
                        }
                    }
                }
//                Nav {
//                    attrs.activeKey = activeTab
//                    attrs.onSelect = { key, _ ->
//                        activeTab = (key as String).toInt()
//                    }
//                    attrs.variant = "tabs"
//                    attrs.fill = true

//                    NavItem {
//                        NavLink {
//                            attrs.eventKey = 0
//                            attrs.role = "tab"
//                            +"Основная информация"
//                        }
//                    }
//                    NavItem {
//                        NavLink {
//                            attrs.eventKey = 1
//                            attrs.role = "tab"
//                            +"Статистика"
//                        }
//                    }
//                    NavItem {
//                        NavLink {
//                            attrs.eventKey = 2
//                            attrs.role = "tab"
//                            +"Карта кликов"
//                        }
//                    }
//                }

            }
        }

        TabContent {
            TabPane {
                attrs.active = activeTab == 0

                div("row flex-row") {
                    widget {
                        attrs.size = "col-12 col-lg-6"
                        attrs.header = "Основная информация"
                        renderInputField("Название", props.campaign.name)
                        renderInputField("Магазин", store?.name.orEmpty())
                        renderInputField("Отправитель", sender?.name.orEmpty())
                    }
                    widget {
                        attrs.size = "col-12 col-lg-6"
                        attrs.header = "Отслеживание"
                        renderInputField("UTM campaign", props.campaign.utmTags.campaign)
                        renderInputField("UTM medium", props.campaign.utmTags.medium)
                        renderInputField("UTM source", props.campaign.utmTags.source)
                    }
                }

            }
            TabPane {
                attrs.active = activeTab == 1

                div("row flex-row") {
                    child(widget) {
                        Table {
                            attrs.bordered = true
                            attrs.hover = true
                            thead("mt-5") {
                                tr {
                                    if ((statistics?.variants?.size ?: 0) > 1) {
                                        th { +"Вариант письма" }
                                    }
                                    th { +"Отправлено" }
                                    th { +"Доставлено" }
                                    th { +"Прочитано" }
                                    th { +"Прочитано (уникальные)" }
                                    th { +"Клики" }
                                    th { +"Клики (уникальные)" }
                                    th { +"Ошибки" }
                                }
                            }
                            tbody {
                                statistics?.let { stats ->
                                    val totalSend = stats.variants.sumOf { it.send }
                                    val totalDelivery = stats.variants.sumOf { it.delivery }
                                    val totalOpen = stats.variants.sumOf { it.open }
                                    val totalOpenUnique = stats.variants.sumOf { it.openUnique }
                                    val totalClick = stats.variants.sumOf { it.click }
                                    val totalClickUnique = stats.variants.sumOf { it.clickUnique }
                                    val totalErrors = stats.variants.sumOf { it.errors }
                                    stats.variants.forEachIndexed { index, variantStats ->
                                        tr {
                                            if (stats.variants.size > 1) {
                                                td { +(index + 1).toString() }
                                            }
                                            td {
                                                var percent = "100%"
                                                if (stats.variants.size > 1) percent =
                                                    "$percent / ${variantStats.send * 100 / totalSend}%"
                                                +"${variantStats.send} ( $percent )"
                                            }
                                            td {
                                                var percent = "${variantStats.delivery * 100 / variantStats.send}%"
                                                if (stats.variants.size > 1) percent =
                                                    "$percent / ${variantStats.delivery * 100 / totalSend}%"
                                                +"${variantStats.delivery} ( $percent )"
                                            }
                                            td {
                                                var percent = "${variantStats.open * 100 / variantStats.delivery}%"
                                                if (stats.variants.size > 1) percent =
                                                    "$percent / ${variantStats.open * 100 / totalDelivery}%"
                                                +"${variantStats.open} ( $percent )"
                                            }
                                            td {
                                                var percent =
                                                    "${variantStats.openUnique * 100 / variantStats.delivery}%"
                                                if (stats.variants.size > 1) percent =
                                                    "$percent / ${variantStats.openUnique * 100 / totalDelivery}%"
                                                +"${variantStats.openUnique} ( $percent )"
                                            }
                                            td {
                                                var percent = "${variantStats.click * 100 / variantStats.open}%"
                                                if (stats.variants.size > 1) percent =
                                                    "$percent / ${variantStats.click * 100 / totalOpen}%"
                                                +"${variantStats.click} ( $percent )"
                                            }
                                            td {
                                                var percent = "${variantStats.clickUnique * 100 / variantStats.open}%"
                                                if (stats.variants.size > 1) percent =
                                                    "$percent / ${variantStats.clickUnique * 100 / totalOpen}%"
                                                +"${variantStats.clickUnique} ( $percent )"
                                            }
                                            td {
                                                var percent = "${variantStats.errors * 100 / variantStats.send}%"
                                                if (stats.variants.size > 1) percent =
                                                    "$percent / ${variantStats.errors * 100 / totalSend}%"
                                                +"${variantStats.errors} ( $percent )"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (activeTab == 1) {
                        child(widget) {

                            if (props.campaign.variants.size > 1) {
                                Nav {
                                    attrs.activeKey = activePreviewTab
                                    attrs.onSelect = { key, _ ->
                                        activePreviewTab = (key as String).toInt()
                                    }
                                    attrs.variant = "tabs"
                                    attrs.fill = true

                                    for (i in 0 until props.campaign.variants.size) {
                                        NavItem {
                                            NavLink {
                                                attrs.eventKey = i
                                                attrs.role = "tab"
                                                +"Вариант ${i + 1}"
                                            }
                                        }
                                    }
                                }
                            }

                            TabContent {
                                props.campaign.variants.forEachIndexed { index, variant ->
                                    TabPane {
                                        attrs.active = activePreviewTab == index
                                        reactEChartsCore {
                                            attrs.option = jso {
                                                tooltip = jso { trigger = "axis" }
                                                legend = jso {
                                                    this.data = arrayOf("Отправлено", "Доставлено", "Открыто", "Клики", "Ошибки")
                                                }
                                                xAxis = jso {
                                                    type = "category"
                                                    boundaryGap = false
                                                    this.data = statistics?.daysStats?.get(activePreviewTab)?.keys?.sortedBy {
                                                        it.toLocalDateTime()
                                                    }?.toTypedArray() ?: arrayOf<String>()
                                                }
                                                yAxis = jso {
                                                    type = "value"
                                                }
                                                series = statistics?.daysStats?.get(activePreviewTab)?.let { stats ->

                                                    val values = stats.entries.sortedBy {
                                                        it.key.toLocalDateTime()
                                                    }.map { it.value }
                                                    arrayOf<dynamic>(
                                                        jso {
                                                            this.data = values.map { it.send }.toTypedArray()
                                                            name = "Отправлено"
                                                            type = "line"
                                                            smooth = true
                                                        },
                                                        jso {
                                                            this.data = values.map { it.delivery }.toTypedArray()
                                                            name = "Доставлено"
                                                            type = "line"
                                                            smooth = true
                                                        },
                                                        jso {
                                                            this.data = values.map { it.open }.toTypedArray()
                                                            name = "Открыто"
                                                            type = "line"
                                                            smooth = true
                                                        },
                                                        jso {
                                                            this.data = values.map { it.click }.toTypedArray()
                                                            name = "Клики"
                                                            type = "line"
                                                            smooth = true
                                                        },
                                                        jso {
                                                            this.data = values.map { it.errors }.toTypedArray()
                                                            name = "Ошибки"
                                                            type = "line"
                                                            smooth = true
                                                        },
                                                    )
                                                } ?: arrayOf<dynamic>()
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        child(widget) {
                            attrs.size = "col-6"
                            reactEChartsCore {
                                attrs.option = jso {
                                    tooltip = jso { trigger = "axis" }
                                    legend = jso {
                                        align = "left"
                                        left = "left"
                                        oriental = "vertical"
                                        this.data = (0 until (statistics?.variants?.size ?: 0)).map {
                                            "Вариант ${it+1}"
                                        }.toTypedArray()
                                    }
                                    radar = jso {

                                        indicator = arrayOf<dynamic>(
                                            jso {
                                                name = "Отправлено"
                                                max = statistics?.variants?.maxOf { it.send } ?: 0
                                            },
                                            jso {
                                                name = "Доставлено"
                                                max = statistics?.variants?.maxOf { it.delivery } ?: 0
                                            },
                                            jso {
                                                name = "Открыто"
                                                max = statistics?.variants?.maxOf { it.open } ?: 0
                                            },
                                            jso {
                                                name = "Уникальные открытия"
                                                max = statistics?.variants?.maxOf { it.openUnique } ?: 0
                                            },
                                            jso {
                                                name = "Клики"
                                                max = statistics?.variants?.maxOf { it.click } ?: 0
                                            },
                                            jso {
                                                name = "Уникальные клики"
                                                max = statistics?.variants?.maxOf { it.clickUnique } ?: 0
                                            },
                                            jso {
                                                name = "Ошибки"
                                                max = statistics?.variants?.maxOf { it.errors } ?: 0
                                            },
                                        )
                                    }
                                    series = arrayOf(
                                        jso<dynamic> {
                                            name = "Сравнение вариантов"
                                            type = "radar"
                                            this.data = statistics?.variants?.mapIndexed { index, stats ->
                                                jso<dynamic> {
                                                    value = arrayOf(stats.send, stats.delivery, stats.open, stats.openUnique, stats.click, stats.clickUnique, stats.errors)
                                                    name = "Вариант ${index+1}"
                                                }
                                            }?.toTypedArray() ?: arrayOf<dynamic>()
                                        }
                                    )
                                }
                            }
                        }
                        child(widget) {
                            attrs.size = "col-6"
                            reactEChartsCore {
                                attrs.option = jso {
                                    title = jso {
                                        text = "Вариант ${activePreviewTab+1}"
                                    }
                                    tooltip = jso {
                                        trigger = "item"
                                        formatter = "{a} <br/>{b} : {c}%"
                                    }
                                    legend = jso {
                                        this.data = arrayOf("Отправлено", "Доставлено", "Открыто", "Клики", "Ошибки")
                                    }
                                    series = arrayOf(
                                        jso<dynamic> {
                                            name = "Вариант ${activePreviewTab+1}"
                                            type = "funnel"
                                            left = "10%"
                                            top = 60
                                            bottom = 60
                                            width = "80%"
                                            min = 0
                                            max = 100
                                            minSize = "0%"
                                            maxSize = "100%"
                                            sort =  "descending"
                                            gap = 2
                                            label = jso {
                                                show = true
                                                position = "inside"
                                            }
                                            labelLine = jso {
                                                length = 10
                                                lineStyle = jso {
                                                    width = 1
                                                    type = "solid"
                                                }
                                            }
                                            itemStyle = jso {
                                                borderColor = "#fff"
                                                borderWidth = 1
                                            }
                                            emphasis = jso {
                                                label = jso {
                                                    fontSize = 20
                                                }
                                            }
                                            this.data = statistics?.variants?.get(activePreviewTab)?.let { stats ->
                                                arrayOf<dynamic>(
                                                    jso {
                                                        value = 100
                                                        name = "Отправлено"
                                                    },
                                                    jso {
                                                        value = stats.delivery * 100 / stats.send
                                                        name = "Доставлено"
                                                    },
                                                    jso {
                                                        value = stats.open * 100 / stats.delivery
                                                        name = "Открыто"
                                                    },
                                                    jso {
                                                        value = stats.click * 100 / stats.open
                                                        name = "Клики"
                                                    },
                                                )
                                            } ?: arrayOf<dynamic>()
                                        }
                                    )
                                }
                            }
                        }
                    }

                }
            }
            TabPane {
                attrs.active = activeTab == 2

                div("row flex-row") {
                    child(widget) {
                        statistics?.let {

//                            if (props.campaign.variants.size > 1) {
//                                Nav {
//                                    attrs.activeKey = activePreviewTab
//                                    attrs.onSelect = { key, _ ->
//                                        activePreviewTab = (key as String).toInt()
//                                    }
//                                    attrs.variant = "tabs"
//                                    attrs.fill = true
//
//                                    for (i in 0 until props.campaign.variants.size) {
//                                        NavItem {
//                                            NavLink {
//                                                attrs.eventKey = i
//                                                attrs.role = "tab"
//                                                +"Вариант ${i + 1}"
//                                            }
//                                        }
//                                    }
//                                }
//                            }

                            TabContent {
                                props.campaign.variants.forEachIndexed { index, variant ->
                                    TabPane {
                                        attrs.active = activePreviewTab == index

                                        iframe {
                                            attrs.src = "/api/v1/campaigns/$id/preview?variant=$index"
                                            ref = r
                                            attrs.id = "preview$index"
                                            attrs.width = "100%"
                                            attrs.height = "600px"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

private fun RBuilder.renderInputField(name: String, value: String) {
    div("form-group row d-flex align-items-center mb-5") {
        label("col-3 form-control-label") { +"$name:" }
        div("col-9") {
            input(InputType.text, classes = "form-control") {
                attrs.value = value
                attrs.contentEditable = false
                attrs.disabled = true
            }
        }
    }
}

fun String.toLocalDateTime(): LocalDateTime {
    val year = if (length >= 10) substring(6..9).toIntOrNull() ?: 0 else 0
    val month = if (length >= 10) substring(3..4).toIntOrNull() ?: 0 else 0
    val day = if (length >= 10) substring(0..1).toIntOrNull() ?: 0 else 0

    val hour = if (length >= 15) substring(11..12).toIntOrNull() ?: 0 else 0
    val minute = if (length >= 15) substring(13..14).toIntOrNull() ?: 0 else 0

    return LocalDateTime(year, month, day, hour, minute)
}